module.exports = __webpack_public_path__ + "static/media/Aviso Importante 29jul21.786dc291.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Aviso Importante 29jul21.pdf
// module id = 247
// module chunks = 0